<template>
  <div id="app" style="margin-top: -25px">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "app",
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    nextRoute() {
      return this.$route.query.redirect;
    }
  },
  watch: {
    user(auth) {
      if (auth) {
        if (this.$route.path.includes("signin")) {
          this.$router.push("/app");
        } else if (this.$route.path !== "/refresh-account-link") {
          this.$router.replace(this.nextRoute);
        }
      }
    },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("SETUP_URL_SETTINGS", query);
    }
  }
};
</script>

<style lang="scss">
@import url("./assets/styles/main.scss");
</style>
